/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferAttachmentDescription
 */
export interface OfferAttachmentDescription {
    /**
     * 
     * @type {string}
     * @memberof OfferAttachmentDescription
     */
    description: string;
}

export function OfferAttachmentDescriptionFromJSON(json: any): OfferAttachmentDescription {
    return OfferAttachmentDescriptionFromJSONTyped(json, false);
}

export function OfferAttachmentDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferAttachmentDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
    };
}

export function OfferAttachmentDescriptionToJSON(value?: OfferAttachmentDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
    };
}


